module.exports = __webpack_public_path__ + "img/test2.102d6c4d.jpeg";